import { combineReducers } from "redux";
import loaderReducer from "./loaderReducer";
// Import other reducers if you have any

const rootReducer = combineReducers({
  loader: loaderReducer,
});

export default rootReducer;
